import React from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { SvgProps } from '../../types/index.d';

export function WordPressIcon({
  className,
  fillColor = '#c9cbcd',
  ariaHidden = true,
}: SvgProps) {
  const t = useT();
  return (
    <svg
      className={className}
      aria-hidden={ariaHidden}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="wordPressCircleLogo"
    >
      <title id="wordPressCircleLogo">
        {t(
          'WordPressIcon.Title',
          'WordPress circle logo',
          'The title for the WordPress logo that is a circle'
        )}
      </title>
      <path
        d="M0.400391 26.0004C0.400391 40.1401 11.8607 51.6004 26.0004 51.6004C40.1373 51.6004 51.6004 40.1401 51.6004 26.0004C51.6004 11.8641 40.1373 0.400391 26.0004 0.400391C11.8612 0.400391 0.400391 11.8641 0.400391 26.0004ZM2.37273 26.0004C2.37174 22.6869 3.06919 19.4103 4.41959 16.3845L15.6898 47.2626C7.8096 43.4368 2.37273 35.3518 2.37273 26.0004ZM26.0004 49.6269C23.681 49.6269 21.4407 49.289 19.3256 48.6672L26.4157 28.0706L33.6781 47.9652C33.7253 48.0829 33.7839 48.1871 33.8448 48.2866C31.3252 49.176 28.6724 49.6293 26.0004 49.6269ZM45.0946 25.5572C46.4423 22.1866 46.8934 19.4917 46.8934 17.0956C46.8934 16.2257 46.8348 15.4185 46.7301 14.6647C48.6341 18.1394 49.6294 22.0388 49.6235 26.001C49.6235 34.7186 44.9012 42.3269 37.8788 46.4207L45.0946 25.5572ZM40.0002 18.2914C40.8967 19.8644 41.9498 21.8868 41.9498 24.808C41.9498 26.8315 41.3479 29.3745 40.1515 32.447L37.7935 40.3182L29.255 14.9241C30.6806 14.8468 31.9584 14.6988 31.9584 14.6988C33.2315 14.5475 33.0796 12.6799 31.8099 12.7498C31.8099 12.7498 27.9818 13.0519 25.5117 13.0519C23.1895 13.0519 19.2903 12.7498 19.2903 12.7498C18.016 12.6799 17.8687 14.6249 19.139 14.6988C19.139 14.6988 20.3468 14.8468 21.6199 14.9241L25.2978 25.01L20.1289 40.5127L11.5222 14.9241C12.9478 14.8468 14.2289 14.6988 14.2289 14.6988C15.5027 14.5475 15.3474 12.6799 14.0776 12.7498C14.0776 12.7498 10.2518 13.0519 7.77888 13.0519C7.33628 13.0519 6.81518 13.0405 6.25995 13.0246C10.4862 6.61038 17.7487 2.37387 26.0004 2.37387C32.1512 2.37387 37.7519 4.72679 41.9537 8.57931C41.8525 8.57134 41.7518 8.55939 41.6505 8.55939C39.3249 8.55939 37.6814 10.5795 37.6814 12.7504C37.682 14.6994 38.8044 16.3463 40.0002 18.2914Z"
        fill={fillColor}
      />
    </svg>
  );
}
